
import styled from "styled-components"
import lineImg from './imgs/line.png';
import bg3 from './imgs/bg3@2x.png';

export const GoodsCard2 = styled.div`
  margin: 12px;
  height: 88px;
  padding: 7px 7px;
  border-radius: 10px;
  background-color:#fff;
  background-size: 100% 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;

  .img_box {
    width: 73px;
    height: 73px;
    img {
      width: 100%;
      height: 100%;
    }
  }
 
  .content {
    flex: 1;
    padding-left:6px;
    letter-spacing: 0px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;

    
  }
  .title {
    .name {
      font-family: Alibaba PuHuiTi;
      font-weight: 800;
      font-size: 15px;
      color: #000000;
      line-height:28px;
    }
    .days {
      color: #FF3E53;
      font-weight: 800;
    }
  }
  .price1 {
    font-family: Arial Black;
    font-weight: 700;
    font-size: 16px;
    color: #FF3E54;
    line-height: 29px;
    // font-style: italic;
  }
  .price2 {
    font-family: Alibaba PuHuiTi;
    font-weight: 500;
    font-size: 12px;
    color: #6E6E6E;
    line-height: 26px;
    margin-left:4px;
  }
  .button_box {
    img {
      width: 70px;
      height: 30px;
    }
  }
`;

export const Line = styled.div`
  padding-top: 15px;
    margin:0 15px;
    height: 25px;
    box-sizing: border-box;

     background-image: url(${lineImg});
    background-repeat: repeat-x;
    background-size: contain;
    background-position: center left;
`




export const ComfirmContainer = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0, 0.82);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  &.hide {
    display: none;
  }
 .title {
    font-weight: bold;
    font-size: 30px;
    color: #000000;
    line-height: 45px;
    .money {
      font-size: 44px;
      color: #ED3535;
    }
  }
  .bg1 {
    text-align: center;
    width: 89.4vw;
    // height: 109vw;
    margin: auto;
    background-image: url(${bg3});
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: relative;
    .content {
      padding-top: 52px;
      left: 0;
      bottom: 0;
      color: black;
    }
  }
  .tips {
    margin-top:10px;
    font-weight: 400;
    font-size: 18px;
    color: #000000;
    line-height: 21px;
    padding:0 20px;
  }
  .content {
     width: 100%;
  }
  
  .footer {
    padding: 24px;
    // width: 100%;
    box-sizing: border-box;
    display:flex;
    justify-content: space-around;
    img {
      height: 40px;
      
      width: 133px;
      +img {
        margin-left: 24px;
      }
    }
    .succss {
       margin-left: 24px;
      width: 133px;
      font-family: Alibaba PuHuiTi;
      width: 133px;
      height: 40px;
      background: linear-gradient(0deg, #FF7083, #FF3E4E);
      border-radius: 19px;
      border: 2px solid;
      border-image: linear-gradient(137deg, #FFB63C, #FF3F58) 4 4
      font-weight: bold;
      font-size: 18px;
      color: #FFFFFF;
      line-height: 40px;
      text-shadow: 0px 0px 35px #FF001A;
    }
  }
  .close {
    position: absolute;
    margin: auto;
    text-align: center;
    left: 50%;
    transform:translatex(-50%);
    bottom: -80px;
    img {
      width: 40px;
    }
  }
`



// WEBPACK FOOTER //
// ./src/views/activity_135/style.js